import { TableCard } from 'app/components'
import { MedicamentosListHeader } from './components/header/MedicamentosListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { MedicamentosTable } from './table/MedicamentosTable'

const MedicamentosList = () => {
  return (
    <TableCard>
      <MedicamentosListHeader />
      <MedicamentosTable />
    </TableCard>
  )
}

export const MedicamentosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <MedicamentosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
